export default __webpack_public_path__ + "static/media/Projects.eeaa7586.png";